import ContentHeader from "../../../components/shared/ContentHeader";

import { PlusOutlined, TeamOutlined } from "@ant-design/icons";
import { TeamContainer } from "./styles";
import { Button } from "antd";
import TeamsCard from "./TeamsCard";
import { useMemo, useState } from "react";
import AddEditTeamDrawer from "./AddEditTeamDrawer";
import { useTenantBranches } from "../../../hooks/useTenantBranches";
import { useTenantTopics } from "../../../hooks/useTenantTopics";
import { useTenantUsers } from "../../../hooks/useTenantUsers";
import { useTenantTeams } from "../../../hooks/useTenantTeams";
import useEnrichedTeams from "./useEnrichedTeams";

const Team = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);
  const {
    branchOptions,
    branches,
    loading: branchLoading,
    selectedTenantId,
  } = useTenantBranches();
  const { topics, loading: topicLoading } = useTenantTopics();
  const { users, loading: userLoading, usersOptions } = useTenantUsers();
  const { teams: fetchedTeams, loading: teamLoading } = useTenantTeams();

  const { teams, isLoading } = useEnrichedTeams({
    fetchedTeams,
    users,
    branches,
    topics,
    teamLoading,
    userLoading,
    topicLoading,
    branchLoading,
  });

  return (
    <TeamContainer>
      <ContentHeader title={"Team Management"} icon={<TeamOutlined />}>
        <Button
          className="add-btn"
          icon={<PlusOutlined />}
          onClick={() => setSelectedTeam({})}
        >
          Create Team
        </Button>
      </ContentHeader>
      <TeamsCard
        teams={teams}
        isLoading={isLoading}
        setSelectedTeam={setSelectedTeam}
      />
      {selectedTeam && (
        <AddEditTeamDrawer
          branchesOptions={branchOptions}
          topics={topics}
          usersOptions={usersOptions}
          selectedTeam={selectedTeam}
          handleClose={() => setSelectedTeam(null)}
          selectedTenantId={selectedTenantId}
        />
      )}
    </TeamContainer>
  );
};

export default Team;
